import react, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Typography } from "antd";
import {
    CrownFilled,
    FireFilled,
    TrophyFilled,
    AimOutlined
} from "@ant-design/icons";

import axios from "axios";
import SnakeGame from "./Snake";
const { Title, Paragraph } = Typography;

const GamesDashboard = () => {
    const navigate = useNavigate();


    const games = [
        {
            id: 1,
            name: "Snake",
            description:
                "El clásico juego de la serpiente. Come la comida y crece, pero cuidado con chocar contigo mismo o con las paredes. Este juego es una versión beta, ¡disfrútalo!",
                
            component: SnakeGame,
        },
        {
            id: 2,
            name: "Trivia",
            description:
                "Pon a prueba tus conocimientos con preguntas de cultura general.",
            component: null,
        },
        {
            id: 3,
            name: "Memory",
            description:
                "Encuentra los pares de cartas iguales.",
            component: null, // Aquí podrías agregar el componente del juego de memoria si lo tienes
        },
    ];

    useEffect(() => {
        const fetchGames = async () => {
            try {
                games.forEach(game => {
                    console.log(`Game: ${game.name} - ${game.description}`);
                });
                //            const response = await axios.get(`${getBackendUrl()}/api/games`);
                // Aquí podrías actualizar el estado con los juegos obtenidos del backend
                // setGames(response.data);
            } catch (error) {
                console.error("Error fetching games:", error);
            }
        };
        fetchGames();
    }, []);

    return (
        <div style={{ padding: "24px" }}>
            <Title level={2}>Juegos</Title>
            <Paragraph>Participa en desafíos y minijuegos para ganar puntos y premios.</Paragraph>
            <Row gutter={[16, 16]}>
                {games.map((game) => (
                    <Col key={game.id} xs={24} sm={12} md={8} lg={6}>
                        <Card
                            hoverable
                            title={game.name}
                            onClick={() => navigate(`/games/${game.name}`)}
                        >
                            <p>{game.description}</p>
                        </Card>

                    </Col>
                ))}
            </Row>



        </div>
    );
};

export default GamesDashboard;